import React from "react";
// import salesAnalyticsImg from "./Sales Analytics.png";
// import ordersFromImg from "./Order KPI.png";
// import OMSPurchaseImg from "./Purchase.png";
// import OMSReturnsImg from "./Returns.png";
import "./OMS order list.css";
import NavBar from "../NavBar";
import CardRender from "../DashboardCardRender";
import DashboardTablesRender from "../DashboardTablesRender";
import { OMSCardData } from "../Dashboard card data";
import {
  OMSDBMarketPlaceTableData,
  OMSDBOrderSummaryTableData,
} from "../DashboardTablesData";
import { OMSBarData1 } from "../BarchartData";
import { OMSColorData } from "../BarColorData";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import data from "../OMSLineGraphData";
import StackedBarChart from "../StackedBarChart";
import TwoLineChart from "../TwoLineChart";
import PieGraph from "../BI/PieGraph";
import DotsComponent from "../DotsComponent";
import OMSTable2 from "./Components/OMSTable2";
import PieCardRender from "../PieCardRender";
import GraphLabel2 from "../Components/GraphLabel2";
import GraphLabel3 from "../Components/GraphLabel3";


export default function OMSDashboard() {
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Order Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Dashboard</h1>
        <div id="Right-content-Down-Filters">
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="right-content-cards">
      <PieCardRender data={OMSCardData[0]} filling={fillingData1} pieColor={PIECOLORS1} pieIndicator={pieIndicator1}/>
      <PieCardRender data={OMSCardData[1]} filling={fillingData2} pieColor={PIECOLORS2} pieIndicator={pieIndicator2}/>
        <CardRender comp={OMSCardData.slice(2,6)} />
      </div>

      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
      <DotsComponent/>
          <div className="graph">
            <div className="chart-head">
              <h1 className="Graph_title">SALES ANALYTICS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel2 color={["#527DFF","#3FD600"]} 
            value={['Expense', 'Income']}
            />
          <TwoLineChart/>
        </div>
        <div className="dashboard-graph">
        <DotsComponent/>  
          <div className="graph">
            <div className="chart-head">
              <h1 className="Graph_title">ORDER TRAFFIC</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel3 color={["#394A7E","#4E6DCB", "#20BF55"]} 
            value={['Amazon', 'Shopify','Flipkart']}
          />
          <StackedBarChart BarData={OMSBarData1} ColorData={OMSColorData}/>
        </div>
      </div>

      {/* Here I rendered the dashboard table1 */}

      <DashboardTablesRender table1Name={OMSDBOrderSummaryTableData} />

      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
        <div className="graph">
            <div className="chart-head">
              <h1 className="Graph_title">PURCHASE</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
        <PieGraph/>
        </div>
        <div className="dashboard-graph">
        <DotsComponent/>
        <div className="graph">
            <div className="chart-head">
              <h1 className="Graph_title">RETURNS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
        <PieGraph/>
        </div>
      </div>
      <OMSTable2 />
    </>
  );
}
const fillingData1 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
];
const PIECOLORS1 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator1 = ["#FFC700", "#F7762E"]

const fillingData2 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
  { name: "Group C", value: 400 },

];
const PIECOLORS2 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator2 = ["#ECECEC","#FFC700", "#F7762E","#FFE754"]